import { Component, HostListener } from '@angular/core';

/**
 * scroll to top button
 * to navigate quickly back to top of page
 * shown when viewport is scrolled down
 * @class ScollTopComponent
 * @typedef {ScollTopComponent}
 */
@Component( {
    selector: 'app-scroll-top',
    templateUrl: './scroll-top.component.html',
    styleUrls: ['./scroll-top.component.scss'],
    standalone: false
} )
export class ScrollTopComponent {
    /**
     * Listener to detect scroll bottom
     * to show the scroll to top button
     */
    @HostListener( 'window:scroll', [] )
    onScroll(): void {
        if ( window.innerWidth < 1240 ) {
            if ( window.innerHeight + window.scrollY > window.innerHeight * 3 - 100 ) {
                document.getElementById( 'btn-scrolltop' )!.style.display = 'flex';
            } else {
                document.getElementById( 'btn-scrolltop' )!.style.display = 'none';
            }
        } else {
            if ( window.innerHeight + window.scrollY > window.innerHeight * 2 - 100 ) {
                document.getElementById( 'btn-scrolltop' )!.style.display = 'flex';
            } else {
                document.getElementById( 'btn-scrolltop' )!.style.display = 'none';
            }
        }
    }
    /** called on button click */
    scrollTop() {
        const element = document.querySelector( '#body-top-anchor' );
        if ( element ) {
            element.scrollIntoView();
        }
    }
}
